import React, { useState, useEffect, Fragment } from "react";
import services from "../services";
import { CardSuspendFilteringSchema } from "../CardSuspendSchema";
import { CardSuspendListing } from "../Pages/listing";
import { PageHeader } from "../../../Common";
import { validateProperty, validate } from "../../Common";
import Joi from "@hapi/joi";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import authService from "../../Common/services";
import tokenService from "../../../Common/tokenDecoder";
import { trackPromise } from "react-promise-tracker";
import { LoadingSpinerComponent } from "../../../Common/loader";

const screenCode = "CARDSUSPEND";

export function CardSuspendFiltering(props) {
  const [title, setTitle] = useState("Suspend Cards");
  const [operationEntities, setOperationEntities] = useState([]);
  const [groups, setGroups] = useState();
  const [collectionPoint, setCollectionPoint] = useState([]);
  const [cardSuspendData, setCardSuspendData] = useState([]);
  const [cardSuspendFilter, setCardSuspendFilter] = useState({
    cardNumber: "",
    collectionPointID: "0",
    firstName: "",
    groupID: "0",
    nameToBePrinted: "",
    operationEntityID: "0",
    registrationNumber: "",
    remark: "",
  });
  const [errors, setErrors] = useState({});
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const schema = Joi.object(CardSuspendFilteringSchema).options({
    allowUnknown: true,
  });

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    trackPromise(getOperationEntityForDropdown());
  }, [cardSuspendFilter.groupID]);

  useEffect(() => {
    trackPromise(getCollectionPointForDropDown());
  }, [cardSuspendFilter.operationEntityID]);

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getOperationEntityForDropdown() {
    const operationEntity = await services.getAllOperationEntitiesForDropDown(
      cardSuspendFilter.groupID
    );
    setOperationEntities(operationEntity);
  }

  async function getCollectionPointForDropDown() {
    const collectionPoint = await services.GetCollectionPointsFilter(
      cardSuspendFilter.operationEntityID
    );
    setCollectionPoint(collectionPoint);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWCARDSUSPENDLISTING"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();

    setCardSuspendFilter({
      ...cardSuspendFilter,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });
    
    trackPromise(
      getGroupsForDropdown()
      );
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setCardSuspendFilter({
      ...cardSuspendFilter,
      groupID: target.value,
      operationEntityID: "0",
      collectionPointID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setCardSuspendFilter({
      ...cardSuspendFilter,
      operationEntityID: target.value,
      collectionPointID: "0",
    });
  }

  function handleCollectionPointChange(target) {
    validateInputs(target);

    setCardSuspendFilter({
      ...cardSuspendFilter,
      collectionPointID: target.value,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, CardSuspendFilteringSchema);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function handleSearch(e) {
    e.preventDefault();

    const errorMessages = validate(schema, cardSuspendFilter);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    const response = await services.getCardSuspendDetails(cardSuspendFilter);
    setCardSuspendData(response);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }
  async function afterSuccessfulyChanged() {
    const response = await services.getCardSuspendDetails(cardSuspendFilter);
    setCardSuspendData(response);
  }
  function clearState() {
    setCardSuspendFilter({
      ...cardSuspendFilter,
      collectionPointID: "0",
    });
    setCardSuspendData([]);
  }

  function onCancelClick() {
    clearState();
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <PageHeader title={title} />
              </div>
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="groupID"
                      name="groupID"
                      value={cardSuspendFilter.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="operationEntityID"
                      name="operationEntityID"
                      value={cardSuspendFilter.operationEntityID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(operationEntities)}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText error>
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md">
                    <InputLabel shrink id="collectionPointID">
                      Collection Point *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="collectionPointID"
                      id="collectionPointID"
                      name="collectionPointID"
                      value={cardSuspendFilter.collectionPointID}
                      onChange={(e) => handleCollectionPointChange(e.target)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(collectionPoint)}
                    </Select>
                    {errors["collectionPointID"] && (
                      <FormHelperText error>
                        {errors["collectionPointID"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>

                <div className="card-footer">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Search"
                  />
                  <input
                    type="button"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>

                <CardSuspendListing
                  cardSuspendData={cardSuspendData}
                  afterSuccessfulyChanged={afterSuccessfulyChanged}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
